'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'court-sport';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e643';
var svgPathData = ['M16 96l0 32 48 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-48 0 0 32c0 26.5 21.5 48 48 48l248 0 0-112.3c-49.3-4.1-88-45.3-88-95.7s38.7-91.6 88-95.7L312 48 64 48C37.5 48 16 69.5 16 96zm0 48l0 224 48 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-48 0zM240 256c0 41.5 31.6 75.6 72 79.6l0-159.2c-40.4 4-72 38.1-72 79.6zM328 48l0 112.3c49.3 4.1 88 45.3 88 95.7s-38.7 91.6-88 95.7l0 112.3 248 0c26.5 0 48-21.5 48-48l0-32-48 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l48 0 0-32c0-26.5-21.5-48-48-48L328 48zm0 128.4l0 159.2c40.4-4 72-38.1 72-79.6s-31.6-75.6-72-79.6zM528 192l0 128c0 26.5 21.5 48 48 48l48 0 0-224-48 0c-26.5 0-48 21.5-48 48z', 'M64 48C37.5 48 16 69.5 16 96l0 32 48 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-48 0 0 32c0 26.5 21.5 48 48 48l248 0 0-112.3c-49.3-4.1-88-45.3-88-95.7s38.7-91.6 88-95.7L312 48 64 48zM328 351.7l0 112.3 248 0c26.5 0 48-21.5 48-48l0-32-48 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l48 0 0-32c0-26.5-21.5-48-48-48l-248 0 0 112.3c49.3 4.1 88 45.3 88 95.7s-38.7 91.6-88 95.7zm0-175.3l0 159.2c40.4-4 72-38.1 72-79.6s-31.6-75.6-72-79.6zm-16 0c-40.4 4-72 38.1-72 79.6s31.6 75.6 72 79.6l0-159.2zM16 144l0 224 48 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-48 0zM576 368l48 0 0-224-48 0c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCourtSport = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;